import { ReactNode } from "react";
import {
  ArrowForward,
  LocalShipping,
  Route,
  ViewModule,
} from "@mui/icons-material";
import { Box, ListItem, Typography } from "@mui/material";
import { AssignmentDetails } from "../../types/assignment.type";
import { ReadOnlyStatusTag } from "../../pages/inbound/shared/ReadOnlyStatusTag";
import { toastMessage } from "../../constants/strings";

export type AutocompleteAvailabilityOptionProps = {
  listItemProps?: React.HTMLAttributes<HTMLLIElement>;
  name: string;
  assignment: AssignmentDetails | null;
  leftIcon?: ReactNode;
};

const greyedOutOpacityStyle = { opacity: 0.54 };

export const AutocompleteAvailabilityOption = ({
  listItemProps,
  name,
  assignment,
  leftIcon,
}: AutocompleteAvailabilityOptionProps) => (
  <ListItem {...listItemProps} key={name}>
    <Box width="auto" display="flex" flexDirection="row">
      {leftIcon && (
        <Box
          display="flex"
          flexDirection="row"
          alignContent="center"
          sx={greyedOutOpacityStyle}
          mr="5px"
        >
          {leftIcon}
        </Box>
      )}
      <Typography mt="2px" mr="10px">
        {name}
      </Typography>
      {assignment?.name && (
        <>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius={2}
            mr="5px"
            sx={{ backgroundColor: "#F5F5F5" }}
          >
            {assignment.type === "Route" ? (
              <Route sx={{ margin: "2px", ...greyedOutOpacityStyle }} />
            ) : assignment.type === "Trap" ? (
              <ViewModule sx={{ margin: "2px", ...greyedOutOpacityStyle }} />
            ) : assignment.type === "Trip" ? (
              <LocalShipping sx={{ margin: "2px", ...greyedOutOpacityStyle }} />
            ) : (
              <ArrowForward sx={{ margin: "2px", ...greyedOutOpacityStyle }} />
            )}
          </Box>
          <Typography mt="2px" sx={greyedOutOpacityStyle}>
            {assignment.name}
          </Typography>
          <Box ml={1}>
            <ReadOnlyStatusTag
              status={assignment.status}
              warningMessage={
                toastMessage.inbound.routeStatusChange.routeTrapNotInPlanStatus
              }
            />
          </Box>
          {assignment.extraAssignmentsCount > 0 && (
            <Typography
              ml={1}
              sx={greyedOutOpacityStyle}
            >{`+${assignment.extraAssignmentsCount} more`}</Typography>
          )}
        </>
      )}
    </Box>
  </ListItem>
);
